import Config from '../../data/SiteConfig';

export const CASHFREE_VENDOR_ID = 5;
const STORE_KEY = 'cashfree-payment';

export const saveCashfreePayment = (p) => sessionStorage.setItem(STORE_KEY, JSON.stringify(p));

export const readCashfreePayment = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORE_KEY));
  } catch (e) {
    return null;
  }
};

export const clearCashfreePayment = () => sessionStorage.removeItem(STORE_KEY);

export const ensureCashfreeSdk = () => {
  return new Promise((resolve, reject) => {
    if (typeof window.Cashfree === 'function') {
      return resolve(window.Cashfree);
    }
    const existingScript = document.querySelector('script[src*="cashfree.com/js/v3/cashfree.js"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if (typeof window.Cashfree === 'function') {
          resolve(window.Cashfree);
        } else {
          reject(new Error('Cashfree SDK script loaded but window.Cashfree is undefined'));
        }
      });
      existingScript.addEventListener('error', () => {
        reject(new Error('Failed to load Cashfree SDK script from CDN'));
      });
      if (typeof window.Cashfree === 'function') {
        return resolve(window.Cashfree);
      }
    } else {
      const script = document.createElement('script');
      script.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
      script.async = true;
      script.onload = () => {
        if (typeof window.Cashfree === 'function') {
          resolve(window.Cashfree);
        } else {
          reject(new Error('Cashfree SDK script loaded but window.Cashfree is undefined'));
        }
      };
      script.onerror = () => {
        reject(new Error('Failed to load Cashfree SDK script from CDN'));
      };
      document.head.appendChild(script);
    }
  });
};

// The promise settles only when Cashfree refuses to open (result.error). Otherwise the tab has already left.
export const openCashfreeCheckout = async (vendorKey, vendorMode) => {
  const Cashfree = await ensureCashfreeSdk();
  const normalizedMode = (vendorMode || 'sandbox').toLowerCase();
  const cashfree = Cashfree({ mode: normalizedMode });
  return cashfree.checkout({
    paymentSessionId: vendorKey,
    redirectTarget: '_self',
    mode: normalizedMode,
  });
};

export const cancelCashfreePayment = (paymentInitiatedId, reason) =>
  fetch(Config.baseLUCIDPaymentAPI + 'CancelOnlinePayment', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('user-token'),
    },
    body: JSON.stringify({ PaymentInitiatedId: paymentInitiatedId, Reason: reason }),
  }).then((res) => res.json());

export const clearPaymentKeys = () => {
  ['paymentInitiatedId', 'vendorTransactionId', 'vendorId', 'vendorName', 'paymentStatus', 'redirect-page']
    .forEach((k) => sessionStorage.removeItem(k));
  clearCashfreePayment();
};
